import script from "./GroupList.vue?vue&type=script&setup=true&lang=ts"
export * from "./GroupList.vue?vue&type=script&setup=true&lang=ts"

import "./GroupList.vue?vue&type=style&index=0&id=2c8e833e&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c8e833e"]])

export default __exports__